import { BookOutlined, DownOutlined, EditOutlined } from '@ant-design/icons'
import { Dropdown, Menu, MenuProps, Tag, Tooltip, Typography } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Favorite, getPointPermission, MosaicComponent, ProjectProgress, UserName } from '@/components'
import { HotResource } from '@/components/hot-resource/hot-resource.component'
import { ProjectEdit } from '@/modules/project/project-create'
import { PAGE_RESOURCE_POINTS_ENUM, Project, ProjectType, ResourceUser } from '@/schemas'

import { ProjectStatus } from './project-status.component'

interface ProjectHeaderContainerProps {
  project: Project
  users?: ResourceUser[]
  refreshProject: () => void
}

export const ProjectHeaderContainer: React.FC<ProjectHeaderContainerProps> = ({ project, users, refreshProject }) => {
  const { t } = useTranslation()
  // const [departments] = useAtom(departmentsAtom)
  // 修复触发 Popconfirm 时 Menu 被自动关闭
  const [visible, setVisible] = React.useState(false)
  const [editVisible, setEditVisible] = React.useState(false)

  const { editable, canRead } = getPointPermission(PAGE_RESOURCE_POINTS_ENUM.概况, project.permissions)

  const onClickMenu: MenuProps['onClick'] = ({ key }) => {
    if (key === 'edit') {
      setEditVisible(true)
      setVisible(false)
    }
  }

  const menu = (
    <Menu onClick={onClickMenu}>
      <Menu.Item key='edit' icon={<EditOutlined />} disabled={!editable || !canRead}>
        {t('project.editInfo')}
      </Menu.Item>
    </Menu>
  )

  return (
    <div className='flex space-x-16px text-sm items-baseline max-w-full truncate'>
      <div>
        <BookOutlined style={{ fontSize: 18 }} />
      </div>

      <Dropdown trigger={['click']} overlay={menu} visible={visible} onVisibleChange={(visible) => setVisible(visible)}>
        <Typography.Text ellipsis className='cursor-pointer text-xl'>
          {project.name}
          <DownOutlined className='ml-4px' />
        </Typography.Text>
      </Dropdown>

      <div>
        <HotResource selfId={project.selfId} type={project.type} />
      </div>
      <div>
        <Favorite selfId={project.selfId} type={project.type} isFavourited={project.isFavourited} />
      </div>

      {project.projectType === ProjectType.RELEASE &&
        (!getPointPermission(PAGE_RESOURCE_POINTS_ENUM.概况_发版项目, project.permissions).canRead ? (
          <MosaicComponent />
        ) : (
          <div>
            <Tag color='#108ee9'>{t('release')}</Tag>
          </div>
        ))}

      <Tooltip title={t('owner')}>
        <div>
          {!getPointPermission(PAGE_RESOURCE_POINTS_ENUM.概况_负责人, project.permissions).canRead ? (
            <MosaicComponent />
          ) : (
            <UserName email={project.email} />
          )}
        </div>
      </Tooltip>

      <ProjectProgress project={project} />

      <ProjectStatus project={project} onChange={refreshProject} users={users} />

      <ProjectEdit
        project={project}
        visible={editVisible}
        onCancel={() => {
          setEditVisible(false)
          refreshProject()
        }}
      />
    </div>
  )
}
